import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const initState = {
  luckyDrawCount: {},
  luckyDrawList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isProcessLoadLuckyDrawList: false,
  luckyDrawDetail: {},
  isProcessLoadLuckyDrawDetail: false,
  luckyDrawPrize: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isProcessLoadLuckyDrawPrize: false,
  luckyDrawParticipant: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isProcessLoadLuckyDrawParticipant: false,
  luckyDrawResult: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isProcessLoadLuckyDrawResult: false,
  newLuckyDrawID: null,
  isCreateLuckyDrawSuccess: false,
  isUpdateLuckyDrawSuccess: false,
  isUpdateLuckyDrawActiveSuccess: false,
  isRemoveLuckyDrawSuccess: false,
  isCreateLuckyDrawPrizeSuccess: false,
  isUpdateLuckyDrawPrizeSuccess: false,
  isRemoveLuckyDrawPrizeSuccess: false,
  isUpdateLuckyDrawParticipantEligibleSuccess: false
};

export default function luckyDrawReducer(state = initState, action) {
  switch (action.type) {
    case actionTypes.LOAD_LUCKY_DRAW_COUNT:
      return { ...state, luckyDrawCount: {} };
    case actionTypes.LOAD_LUCKY_DRAW_COUNT_SUCCESS:
      return { ...state, luckyDrawCount: action.data };
    case actionTypes.LOAD_LUCKY_DRAW_COUNT_FAIL:
      return { ...state };

    case actionTypes.LOAD_LUCKY_DRAW_LIST: {
      const luckyDrawList = cloneDeep(state.luckyDrawList);
      if (action.data && Object.keys(action.data).includes("offset") && Object.keys(action.data).includes("limit")) {
        luckyDrawList.offset = action.data.offset;
        luckyDrawList.limit = action.data.limit;
      }
      return { ...state, luckyDrawList, isProcessLoadLuckyDrawList: true };
    }
    case actionTypes.LOAD_LUCKY_DRAW_LIST_SUCCESS: {
      const luckyDrawList = cloneDeep(state.luckyDrawList);
      luckyDrawList.data = action.data.data;
      luckyDrawList.meta = {
        page: 1 + state.luckyDrawList.offset / state.luckyDrawList.limit,
        pageSize: state.luckyDrawList.limit,
        pageTotal: Math.ceil(action.data.recordsTotal / state.luckyDrawList.limit),
        total: action.data.recordsTotal
      };
      return { ...state, luckyDrawList, isProcessLoadLuckyDrawList: false };
    }
    case actionTypes.LOAD_LUCKY_DRAW_LIST_FAIL:
      return { ...state, isProcessLoadLuckyDrawList: false };

    case actionTypes.LOAD_LUCKY_DRAW_DETAIL:
      return { ...state, luckyDrawDetail: {}, isProcessLoadLuckyDrawDetail: true };
    case actionTypes.LOAD_LUCKY_DRAW_DETAIL_SUCCESS:
      return { ...state, luckyDrawDetail: action.data, isProcessLoadLuckyDrawDetail: false };
    case actionTypes.LOAD_LUCKY_DRAW_DETAIL_FAIL:
      return { ...state, isProcessLoadLuckyDrawDetail: false };


    case actionTypes.CREATE_LUCKY_DRAW:
      return { ...state, isCreateLuckyDrawSuccess: false, newLuckyDrawID: null };
    case actionTypes.CREATE_LUCKY_DRAW_SUCCESS:
      return { ...state, isCreateLuckyDrawSuccess: true, newLuckyDrawID: action.data };
    case actionTypes.CREATE_LUCKY_DRAW_FAIL:
      return { ...state, isCreateLuckyDrawSuccess: false, newLuckyDrawID: null };

    case actionTypes.UPDATE_LUCKY_DRAW:
      return { ...state, isUpdateLuckyDrawSuccess: false };
    case actionTypes.UPDATE_LUCKY_DRAW_SUCCESS:
      return { ...state, isUpdateLuckyDrawSuccess: true };
    case actionTypes.UPDATE_LUCKY_DRAW_FAIL:
      return { ...state, isUpdateLuckyDrawSuccess: false };

    case actionTypes.UPDATE_LUCKY_DRAW_ACTIVE:
      return { ...state, isUpdateLuckyDrawActiveSuccess: false };
    case actionTypes.UPDATE_LUCKY_DRAW_ACTIVE_SUCCESS:
      return { ...state, isUpdateLuckyDrawActiveSuccess: true };
    case actionTypes.UPDATE_LUCKY_DRAW_ACTIVE_FAIL:
      return { ...state, isUpdateLuckyDrawActiveSuccess: false };

    case actionTypes.REMOVE_LUCKY_DRAW:
      return { ...state, isRemoveLuckyDrawSuccess: false };
    case actionTypes.REMOVE_LUCKY_DRAW_SUCCESS:
      return { ...state, isRemoveLuckyDrawSuccess: true };
    case actionTypes.REMOVE_LUCKY_DRAW_FAIL:
      return { ...state, isRemoveLuckyDrawSuccess: false };

    case actionTypes.CREATE_LUCKY_DRAW_PRIZE:
      return { ...state, isCreateLuckyDrawPrizeSuccess: false };
    case actionTypes.CREATE_LUCKY_DRAW_PRIZE_SUCCESS:
      return { ...state, isCreateLuckyDrawPrizeSuccess: true };
    case actionTypes.CREATE_LUCKY_DRAW_PRIZE_FAIL:
      return { ...state, isCreateLuckyDrawPrizeSuccess: false };

    case actionTypes.UPDATE_LUCKY_DRAW_PRIZE:
      return { ...state, isUpdateLuckyDrawPrizeSuccess: false };
    case actionTypes.UPDATE_LUCKY_DRAW_PRIZE_SUCCESS:
      return { ...state, isUpdateLuckyDrawPrizeSuccess: true };
    case actionTypes.UPDATE_LUCKY_DRAW_PRIZE_FAIL:
      return { ...state, isUpdateLuckyDrawPrizeSuccess: false };

    case actionTypes.REMOVE_LUCKY_DRAW_PRIZE:
      return { ...state, isRemoveLuckyDrawPrizeSuccess: false };
    case actionTypes.REMOVE_LUCKY_DRAW_PRIZE_SUCCESS:
      return { ...state, isRemoveLuckyDrawPrizeSuccess: true };
    case actionTypes.REMOVE_LUCKY_DRAW_PRIZE_FAIL:
      return { ...state, isRemoveLuckyDrawPrizeSuccess: false };
      

    case actionTypes.LOAD_LUCKY_DRAW_PRIZE: {
      const luckyDrawPrize = cloneDeep(state.luckyDrawPrize);
      if (action.data && Object.keys(action.data).includes("offset") && Object.keys(action.data).includes("limit")) {
        luckyDrawPrize.offset = action.data.offset;
        luckyDrawPrize.limit = action.data.limit;
      }
      return { ...state, luckyDrawPrize, isProcessLoadLuckyDrawPrize: true };
    }
    case actionTypes.LOAD_LUCKY_DRAW_PRIZE_SUCCESS: {
      const luckyDrawPrize = cloneDeep(state.luckyDrawPrize);
      luckyDrawPrize.data = action.data.data;
      luckyDrawPrize.meta = {
        page: 1 + state.luckyDrawPrize.offset / state.luckyDrawPrize.limit,
        pageSize: state.luckyDrawPrize.limit,
        pageTotal: Math.ceil(action.data.recordsTotal / state.luckyDrawPrize.limit),
        total: action.data.recordsTotal
      };
      return { ...state, luckyDrawPrize, isProcessLoadLuckyDrawPrize: false };
    }
    case actionTypes.LOAD_LUCKY_DRAW_PRIZE_FAIL:
      return { ...state, isProcessLoadLuckyDrawPrize: false };



    case actionTypes.LOAD_LUCKY_DRAW_PARTICIPANT: {
      const luckyDrawParticipant = cloneDeep(state.luckyDrawParticipant);
      if (action.data && Object.keys(action.data).includes("offset") && Object.keys(action.data).includes("limit")) {
        luckyDrawParticipant.offset = action.data.offset;
        luckyDrawParticipant.limit = action.data.limit;
      }
      return { ...state, luckyDrawParticipant, isProcessLoadLuckyDrawParticipant: true };
    }
    case actionTypes.LOAD_LUCKY_DRAW_PARTICIPANT_SUCCESS: {
      const luckyDrawParticipant = cloneDeep(state.luckyDrawParticipant);
      luckyDrawParticipant.data = action.data.data;
      luckyDrawParticipant.meta = {
        page: 1 + state.luckyDrawParticipant.offset / state.luckyDrawParticipant.limit,
        pageSize: state.luckyDrawParticipant.limit,
        pageTotal: Math.ceil(action.data.recordsTotal / state.luckyDrawParticipant.limit),
        total: action.data.recordsTotal
      };
      return { ...state, luckyDrawParticipant, isProcessLoadLuckyDrawParticipant: false };
    }
    case actionTypes.LOAD_LUCKY_DRAW_PARTICIPANT_FAIL:
      return { ...state, isProcessLoadLuckyDrawParticipant: false };

    case actionTypes.UPDATE_LUCKY_DRAW_PARTICIPANT_ELIGIBLE:
      return { ...state, isUpdateLuckyDrawParticipantEligibleSuccess: false };
    case actionTypes.UPDATE_LUCKY_DRAW_PARTICIPANT_ELIGIBLE_SUCCESS:
      return { ...state, isUpdateLuckyDrawParticipantEligibleSuccess: true };
    case actionTypes.UPDATE_LUCKY_DRAW_PARTICIPANT_ELIGIBLE_FAIL:
      return { ...state, isUpdateLuckyDrawParticipantEligibleSuccess: false };
      

    case actionTypes.LOAD_LUCKY_DRAW_RESULT: {
      const luckyDrawResult = cloneDeep(state.luckyDrawResult);
      if (action.data && Object.keys(action.data).includes("offset") && Object.keys(action.data).includes("limit")) {
        luckyDrawResult.offset = action.data.offset;
        luckyDrawResult.limit = action.data.limit;
      }
      return { ...state, luckyDrawResult, isProcessLoadLuckyDrawResult: true };
    }
    case actionTypes.LOAD_LUCKY_DRAW_RESULT_SUCCESS: {
      const luckyDrawResult = cloneDeep(state.luckyDrawResult);
      luckyDrawResult.data = action.data.data;
      luckyDrawResult.meta = {
        page: 1 + state.luckyDrawResult.offset / state.luckyDrawResult.limit,
        pageSize: state.luckyDrawResult.limit,
        pageTotal: Math.ceil(action.data.recordsTotal / state.luckyDrawResult.limit),
        total: action.data.recordsTotal
      };
      return { ...state, luckyDrawResult, isProcessLoadLuckyDrawResult: false };
    }
    case actionTypes.LOAD_LUCKY_DRAW_RESULT_FAIL:
      return { ...state, isProcessLoadLuckyDrawResult: false };

    default:
      return state;
  }
}